// extracted by mini-css-extract-plugin
export default {"alert":"notification-alert_alert__4DEpk","secondary-button":"notification-alert_secondary-button__+GKc3","primary-button":"notification-alert_primary-button__CYhbY"};